/* ============================================
   ArquiConstruye — Smooth Experience 2026
   Advanced Scroll Reveals + Parallax
   Pure IntersectionObserver — No Dependencies
   ============================================ */

(function () {
  'use strict';

  // Respect reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // --- Scroll Progress Bar ---
  var progress = document.createElement('div');
  progress.className = 'arq-progress';
  document.body.appendChild(progress);

  function updateProgress() {
    var scrollTop = window.scrollY;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight > 0) {
      progress.style.width = (scrollTop / docHeight) * 100 + '%';
    }
  }

  // --- Decorative Lines ---
  function createLines() {
    var lines = document.createElement('div');
    lines.className = 'arq-lines';
    for (var i = 0; i < 4; i++) {
      lines.appendChild(document.createElement('span'));
    }
    document.body.appendChild(lines);
    setTimeout(function () { lines.classList.add('visible'); }, 2500);
  }

  // --- Scroll Indicator in Hero ---
  function createScrollIndicator() {
    var hero = document.querySelector('slideshow-component, .banner');
    if (!hero) return;

    var indicator = document.createElement('div');
    indicator.className = 'arq-scroll-indicator';
    indicator.innerHTML = '<span>Scroll</span><div class="arq-scroll-line"></div>';

    // Append to the slideshow component or banner parent
    var parent = document.querySelector('slideshow-component') || hero.closest('.shopify-section');
    if (parent) {
      parent.style.position = 'relative';
      parent.appendChild(indicator);
    }

    // Fade out indicator on scroll
    var hidden = false;
    window.addEventListener('scroll', function () {
      if (!hidden && window.scrollY > 150) {
        indicator.style.transition = 'opacity 0.6s ease';
        indicator.style.opacity = '0';
        hidden = true;
      }
    }, { passive: true });
  }

  // --- Step Numbers for Multicolumn (Pasos) ---
  function addStepNumbers() {
    var multicolumn = document.querySelector('.multicolumn');
    if (!multicolumn) return;

    var cards = multicolumn.querySelectorAll('.multicolumn-card');
    cards.forEach(function (card, i) {
      card.setAttribute('data-step', '0' + (i + 1));
    });
  }

  // --- Advanced Scroll Reveal System ---
  function initReveal() {
    var sections = document.querySelectorAll('.content-for-layout > .shopify-section');

    sections.forEach(function (section) {
      // Skip header/footer, custom arq-home section, collection pages, and dark pages
      if (section.classList.contains('shopify-section-group-header-group') ||
          section.classList.contains('shopify-section-group-footer-group')) return;
      if (document.body.classList.contains('arq-dark-page')) return;
      if (section.querySelector('.arq')) return;
      if (section.querySelector('.arq-coll')) return;
      if (section.querySelector('.facets-vertical, .product-grid, #product-grid')) return;
      if (section.querySelector('.arq-footer')) return;

      // --- HERO: no reveal needed (CSS handles entry animation) ---
      if (section.querySelector('slideshow-component, .slideshow')) return;

      // --- CONOCENOS (image-with-text / lumin-mega): clip reveal on image, slide on content ---
      var imageMedia = section.querySelector('.image-with-text__media');
      var imageContent = section.querySelector('.image-with-text__content');
      if (imageMedia && imageContent) {
        imageMedia.classList.add('arq-reveal');
        imageContent.classList.add('arq-reveal');
        // Stagger the content children (heading, text, icons)
        var contentInner = imageContent.querySelector('.image-with-text__text-item');
        if (contentInner) contentInner.classList.add('arq-stagger');
        return;
      }

      // --- GRIDS: each grid cell gets staggered reveal ---
      var gridRow = section.querySelector('[class*="row-template"]');
      if (gridRow) {
        gridRow.classList.add('arq-stagger');
        // Also add heading reveal
        var gridHeading = section.querySelector('.text-block');
        if (gridHeading) gridHeading.classList.add('arq-reveal');
        return;
      }

      // --- VIDEO OVERLAY: scale reveal ---
      var videoOverlay = section.querySelector('.video-with-text-overlay');
      if (videoOverlay) {
        var videoContainer = videoOverlay.querySelector('[class*="video-container"]');
        if (videoContainer) videoContainer.classList.add('arq-reveal-scale');
        var videoHeading = videoOverlay.querySelector('h2, .h1');
        if (videoHeading) videoHeading.classList.add('arq-reveal');
        return;
      }

      // --- TESTIMONIALS (lumin-multicolumns): stagger cards ---
      var luminMulti = section.querySelector('[class*="lumin-multicolumns"]');
      if (luminMulti) {
        var luminTitle = luminMulti.querySelector('.title');
        if (luminTitle) luminTitle.classList.add('arq-reveal');
        var luminList = luminMulti.querySelector('.multicolumn-list');
        if (luminList) luminList.classList.add('arq-stagger');
        return;
      }

      // --- MULTICOLUMN (Pasos): stagger items ---
      var multicolumn = section.querySelector('.multicolumn');
      if (multicolumn) {
        var mcTitle = multicolumn.querySelector('.title');
        if (mcTitle) mcTitle.classList.add('arq-reveal');
        var mcList = multicolumn.querySelector('.multicolumn-list');
        if (mcList) mcList.classList.add('arq-stagger');
        return;
      }

      // --- RICH TEXT: heading reveal ---
      var richText = section.querySelector('.rich-text');
      if (richText) {
        var rtHeading = richText.querySelector('.rich-text__heading');
        if (rtHeading) rtHeading.classList.add('arq-reveal');
        return;
      }

      // --- DEFAULT: generic reveal on first meaningful child ---
      var inner = section.querySelector(
        '.section, .rich-text, .multicolumn, .image-with-text, ' +
        '.collapsible-content, .lm-video-container, .lumin-section__main, ' +
        '.custom-divider, [class*="lumin-grids"], ' +
        '[class*="lumin-multicolumns"], [class*="featured-collection"]'
      );
      if (inner) {
        inner.classList.add('arq-reveal');
      } else {
        section.classList.add('arq-reveal');
      }
    });

    // Footer trust badges
    var footerBadges = document.querySelectorAll(
      '.shopify-section-group-footer-group .feature-type1'
    );
    footerBadges.forEach(function (s) { s.classList.add('arq-reveal'); });

    // --- Create Observer ---
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('arq-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -120px 0px'
    });

    // Observe all reveal elements
    document.querySelectorAll(
      '.arq-reveal, .arq-reveal-scale, .arq-reveal-clip, ' +
      '.arq-reveal-left, .arq-reveal-right, .arq-stagger'
    ).forEach(function (el) {
      observer.observe(el);
    });
  }

  // --- CSS Parallax on Images ---
  function initParallax() {
    var images = document.querySelectorAll(
      '.multicolumn-card .media img, ' +
      '.lumin-image-template img, ' +
      '.image-with-text__media img'
    );

    if (!images.length) return;

    // Set initial state
    images.forEach(function (img) {
      var parent = img.closest('.media') || img.closest('.lumin-image-template') || img.closest('.image-with-text__media');
      if (parent) {
        parent.style.overflow = 'hidden';
        img.style.transition = 'transform 0.1s linear';
        img.style.willChange = 'transform';
      }
    });

    function updateParallax() {
      var scrollY = window.scrollY;
      var winH = window.innerHeight;

      images.forEach(function (img) {
        var rect = img.getBoundingClientRect();
        // Only process visible images
        if (rect.bottom < -100 || rect.top > winH + 100) return;

        var center = rect.top + rect.height / 2;
        var offset = (center - winH / 2) / winH;
        var translate = offset * -25; // subtle parallax
        img.style.transform = 'translateY(' + translate + 'px) scale(1.05)';
      });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Initial call
    updateParallax();
  }

  // --- Passive Scroll Listener for Progress ---
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateProgress();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // --- Init Everything ---
  function init() {
    createLines();
    createScrollIndicator();
    addStepNumbers();
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
